import { useIsAuthenticated } from '@azure/msal-react';
import { CdButton, CdPublicHeader, CdPublicTemplate, CdSiteFooter } from '@ui';
import { useTranslation } from 'react-i18next';
import { Outlet, ScrollRestoration, useNavigate } from 'react-router';
import { paths } from '@/app/router/paths';
import { useSignIn } from '@/modules/account/auth/useSignIn';
import { useLanguage } from '@/i18n/useLanguage';
import { RouterLink } from '@/shared/components/RouterLink';

export const PublicLayout = () => {
  const { t } = useTranslation('common');
  const { t: tNav } = useTranslation('navigation');
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const signIn = useSignIn();
  const { languages, language, setLanguage, label: languageLabel } = useLanguage();

  return (
    <CdPublicTemplate
      skipLinkLabel={t('skipToContent')}
      header={
        <CdPublicHeader
          linkAs={RouterLink}
          homeHref={paths.landing}
          helpHref={paths.help}
          helpLabel={t('help')}
          languages={languages}
          language={language}
          onLanguageChange={setLanguage}
          languageLabel={languageLabel}
          signInLabel={t('signIn')}
          onSignIn={isAuthenticated ? () => void navigate(paths.dashboard) : signIn}
          endSlot={
            isAuthenticated ? (
              <CdButton variant="tertiary" size="sm" onClick={() => void navigate(paths.dashboard)}>
                {tNav('dashboard')}
              </CdButton>
            ) : undefined
          }
        />
      }
      footer={
        <CdSiteFooter
          linkAs={RouterLink}
          copyright={t('copyright', { year: new Date().getFullYear() })}
          links={[
            { label: t('footer.privacy'), href: '/privacy' },
            { label: t('footer.terms'), href: '/terms' },
            { label: t('footer.accessibility'), href: '/accessibility' },
          ]}
        />
      }
    >
      <Outlet />
      <ScrollRestoration />
    </CdPublicTemplate>
  );
};
